import { render, staticRenderFns } from "./effectCard.vue?vue&type=template&id=30ddfc9a&scoped=true&"
import script from "./effectCard.vue?vue&type=script&lang=js&"
export * from "./effectCard.vue?vue&type=script&lang=js&"
import style0 from "./effectCard.vue?vue&type=style&index=0&id=30ddfc9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ddfc9a",
  null
  
)

export default component.exports